import { render, staticRenderFns } from "./ModalDoutrina.vue?vue&type=template&id=30d80eb0&scoped=true"
import script from "./ModalDoutrina.vue?vue&type=script&lang=js"
export * from "./ModalDoutrina.vue?vue&type=script&lang=js"
import style0 from "./ModalDoutrina.vue?vue&type=style&index=0&id=30d80eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d80eb0",
  null
  
)

export default component.exports